import React from 'react';
import { FadeIn } from './ui';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-brand-dark" data-id="element-59">
      <div className="max-w-4xl mx-auto" data-id="element-60">
        <FadeIn data-id="element-61">
          <div className="bg-gradient-to-br from-brand-card to-black border-2 border-brand-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-62">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-gold via-brand-orange to-brand-gold" data-id="element-63" />

            <ShieldCheck className="w-20 h-20 text-brand-gold mx-auto mb-8" data-id="element-64" />

            <h2 className="font-bebas text-4xl md:text-5xl text-white mb-6" data-id="element-65">
              Garantía de "Energía de Hierro" de 30 Días
            </h2>

            <p className="text-lg md:text-xl text-zinc-300 leading-relaxed max-w-2xl mx-auto" data-id="element-66">
              Si en un mes no te sientes con más fuerza, si no duermes mejor o
              si simplemente no te gusta el color del ebook, te devuelvo cada
              centavo. Te quedas con el material. Sin preguntas.{' '}
              <strong className="text-brand-gold" data-id="element-67">El riesgo es mío.</strong>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}